import React from "react";
import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import TransactionLogsComp from "../../../components/usermembership/transactionlogscomp";

export default function TransactionLogs() {
    return (
        <>
            <UserProfileLayout>
                <TransactionLogsComp/>
            </UserProfileLayout>
        </>
    )
}